export default __webpack_public_path__ + "static/media/FHash3.0c138d91.mp3";